import React from 'react';
import AdvantageView from './AdvantageView';
import { SUBSCRIPTION_ADVANTAGES } from '../../_helpers/constants';

const SubscriptionAdvantagesView = () => {
  return (
    <div className="tw-flex tw-items-center tw-justify-center  tw-rounded-2xl  tw-px-5 tw-py-5 md:tw-py-[60px] tw-border-solid tw-border tw-border-[#C7C7C7]">
      <div className="tw-w-full">
        <div className="tw-grid md:tw-grid-cols-3 tw-gap-6 ">
          {SUBSCRIPTION_ADVANTAGES.map((advantage, index) => (
            <AdvantageView advantage={advantage}/>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionAdvantagesView;